<template>
  <span class="image-box-tool">
    <template>
      <span v-hotkey="keymap" />
    </template>
    <button
      v-if="show"
      type="button"
      class="image-row__button"
      :class="`${disabled ? 'image-row__button--disabled' : ''}
          ${block ? 'image-row__button--block' : ''}
          ${customClasses}`"
      @click="action"
    >

      <div class="d-flex align-items-center">
        <base-icon
          :icon="icon"
          class="mr-2"
        />
        <div>{{ title }}</div>
      </div>
    </button>
  </span>
</template>
<script>
export default {
  name: 'ImageBoxTool',
  inject: ['parent'],
  props: {
    customClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parent: this.parent,
      icon: 'bug',
      title: 'Title',
      block: false,

      hotkey: undefined,
    };
  },
  computed: {
    canvas() {
      return this.parent.canvas;
    },
    show() {
      return true;
    },
    disabled() {
      return false;
    },
    keymap() {
      const keymapDict = {};
      [this.hotkey].flat().forEach((hotkey) => {
        keymapDict[hotkey] = this.action;
      });
      return keymapDict;
    },
  },
  methods: {
    action() {
      console.log('Action was not defined');
    },
  },
};
</script>
<style>
.image-box-tool {
  position: relative;
}
.image-row__button{
  /* width: 100%;
  text-align: left; */
}
.image-row__button--block{
  width: 100%;
  text-align: left;
}
.image-row__button--disabled{
  opacity: 0.1;
  cursor: not-allowed;
}
.text--left{
  text-align: left;
}
</style>
